import { createSlice } from "@reduxjs/toolkit";
import Api from "utils/api/Api";

const initialState = {code:null, name:null};
const schoolSlice = createSlice({
    initialState,
    name:'school',
    reducers:{
        loading:(state)=>initialState,
        fetch:(state, action)=>action.payload,
    }
});
const schoolAction = schoolSlice.actions;
export default schoolSlice.reducer;

export const fetchSchool = (code)=>{
    return (dispatch)=>{
        dispatch(schoolAction.loading());
        //어차피 학교정보가 변경되거나 
        return Api.get(`/api/school/${code}`).then(res=>{
                if(res?.data) dispatch(setSchool(res.data));
            });
    }
}
export const setSchool = (school)=>{
    return (dispatch)=>{
        window.schoolCode = school.code;
        sessionStorage.setItem("schoolCode", school.code);
        sessionStorage.setItem("schoolName", school.name);
        dispatch(schoolAction.fetch(school));
    }
}